import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IELTData } from 'legacy/lut/classes/models/partner360/ELT/IELTData'

import { CrudStore } from 'core/types/crudStore'

export const getVersionCrud = (sourceKey?: string) => {
  if (sourceKey) {
    return CrudStore.get<IELTData>(CrudStoreItemPartner360.JBPEltData, sourceKey)
  }
  return CrudStore.get<IELTData>(CrudStoreItemPartner360.JBPEltData)
}
